import React, { useState, useEffect } from 'react';
import ContactInfoWidget from '../Widget/ContactInfoWidget';
import MenuWidget from '../Widget/MenuWidget';
import SocialWidget from '../Widget/SocialWidget';
import TextWidget from '../Widget/TextWidget';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  
  // State to control the visibility of menu links
  const [showMenuLinks, setShowMenuLinks] = useState(false);

  // Set up timer to show menu links after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowMenuLinks(true);
    }, 5000); // 5 seconds delay
    
    // Clean up timer if component unmounts
    return () => clearTimeout(timer);
  }, []);

  // Lista de claves donde:
  // - item.key es la clave para el título
  // - item.key + "_url" es la clave para la URL
  // const menuItemsOne = [
  //   { key: '/la-agencia-lider-en-gestacion-subrogada-en-colombia/' },
  //   { key: '/' },
  //   { key: '/paises-donde-hacer-una-gestacion-maternidad-subrogada/' },
  //   { key: '/blog/' },
  //   { key: '/politica-cookies/' },
  // ];
  // const menuItemsTwo = [
  //   { key: '/trabaja-en-gestlife/' },
  //   { key: '/faq/' },
  //   { key: '/contacto/' },
  //   { key: '/aviso-legal-proteccion-datos/' },
  // ];

  // /**
  //  * Obtiene las traducciones del idioma actual sin usar fallback,
  //  * y las filtra para mostrar solo las que realmente existen.
  //  */
  // const getMenuData = (items) => {
  //   // Obtenemos el objeto de traducciones correspondiente al idioma actual
  //   const currentTranslations = i18n.getDataByLanguage(i18n.language)?.translation || {};

  //   return items
  //     .filter((item) => {
  //       // Verificamos directamente si existen las claves en las traducciones del idioma actual
  //       const titleExists = typeof currentTranslations[item.key] === 'string' && currentTranslations[item.key].trim() !== '';
  //       const urlExists = typeof currentTranslations[item.key + '_url'] === 'string' && currentTranslations[item.key + '_url'].trim() !== '';

  //       return titleExists && urlExists;
  //     })
  //     .map((item) => {
  //       // Ahora sí usamos t() para obtener la traducción, 
  //       // o podríamos usar directamente currentTranslations[item.key].
  //       const title = t(item.key);
  //       const href = t(item.key + '_url');

  //       return { title, href };
  //     });
  // };

    // Static menu items with title and URL directly set
    const menuItemsOne = [
      { title: 'Nosotros', href: '/la-agencia-lider-en-gestacion-subrogada-en-colombia/' },
      { title: 'Home', href: '/' },
      { title: 'Países', href: '/paises-donde-hacer-una-gestacion-maternidad-subrogada/' },
      { title: 'Blog', href: '/blog/' },
      { title: 'Política de Cookies', href: '/politica-cookies/' },
    ];
  
    const menuItemsTwo = [
      { title: 'Trabaja en Gestlife', href: '/trabaja-en-gestlife/' },
      { title: 'FAQ', href: '/faq/' },
      { title: 'Contacto', href: '/contacto/' },
      { title: 'Aviso Legal y Protección de Datos', href: '/aviso-legal-proteccion-datos/' },
    ];

 // The menu data will be directly the static items
 const menuDataOne = menuItemsOne;
 const menuDataTwo = menuItemsTwo;

  return (
    <footer className="cs_footer cs_style_1 cs_heading_color">
      <div
        className="cs_footer_logo_wrap"
        style={{ background: "linear-gradient(40deg, #EE6FBB, #7BADD3)" }}
      ></div>
      <div className="cs_footer_main">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="cs_footer_item">
                <TextWidget text="Gestlife <br />Surrogacy" />
                <ContactInfoWidget />
              </div>
            </div>
            <div className="col-lg-2">
              <div className="cs_footer_item">
                {showMenuLinks ? (
                  menuDataOne.length > 0 && <MenuWidget data={menuDataOne} />
                ) : (
                  <div className="menu-loading" style={{ height: '150px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <span>{t('loading_links', 'Loading links...')}</span>
                  </div>
                )}
              </div>
            </div>
            <div className="col-lg-2">
              <div className="cs_footer_item">
                {showMenuLinks ? (
                  menuDataTwo.length > 0 && <MenuWidget data={menuDataTwo} />
                ) : (
                  <div className="menu-loading" style={{ height: '150px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <span>{t('loading_links', 'Loading links...')}</span>
                  </div>
                )}
              </div>
            </div>
            {/* <div className="col-lg-4">
              <div className="cs_footer_item">
                <Newsletter
                  title={t('suscribe_footer')}
                  subTitle={t('receive_info_footer')}
                />
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <div className="cs_footer_bottom cs_bg_transparent">
        <div className="container">
          <div className="cs_footer_bottom_in">
            <SocialWidget />
            <div className="cs_copyright">
              Copyright © 2024 Gestlife. Todos los derechos reservados.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}